import { apis, apis2 } from '.';
import http from './http';

export default class OpenEngineerApi {
  static batchEnable (param: {
    engineerIds: Array<number>,
    enabled: boolean
  }) {
    return http.post(apis2.OpenEngineerApi.batchEnable, param)
  }

  static multiCondition (param: {
    engineerQuery?: {
      defaultServiceDeskId: number | null,
      serviceDeskId: number | null,
      email: string,
      name: string,
      pageOrderType: string,
      pageSort: string,
      phone: string,
      roleId: number | null,
      externalId: string,
      searchKey: string,
      searchType: string | null
    },
    page: {
      pageNumber: number,
      pageSize: number
    },
    status: number | null
  }) {
    return http.post(apis2.OpenEngineerApi.multiCondition, param)
  }
  
  static listRole () {
    return http.post(apis2.OpenEngineerApi.listRole, {})
  }

  /**
   * @description 获取客服列表
   * */ 
  static getEngineers (param: {
    queryUserType?: string
  }) {
    return http.get(apis.get_engineers, param)
  }

  /**
   * @description 批量删除客服
   * */ 
  static deleteEngineers (param: {
    ids: string
  }) {
    return http.post(apis.batch_delete_engineers, param)
  }

  /**
   * @description 停用启用账号
   * */ 
  static enableEngineers (param: {
    enable: boolean,
    engieers: Array<any>
  }) {
    return http.post(apis.batch_enable_engineers, param)
  }

  /**
   * @description 获取客服的导出项
   * */
  static getChecks () {
    return http.post(apis.get_checks)
  }

  /**
   * @description 读取上传的客服
   * */
   static importEngineerExcel (formData: any) {
    return http.post(
      apis.resolve_engineer_excel, 
      formData, 
      { 
        'Content-Type': 'multipart/form-data'
      }
    )
  }

  /**
   * @description 读取上传的客服
   * */
   static importEngineer (update: boolean, param: any) {
    return http.post(apis.import_engineer + update, param)
  }

  /**
   * @description 修改客服部门
   * */ 
  static updateServiceDesks (param: {
    engineerId: number,
    defaultServiceDeskId: number,
    serviceDeskIds: Array<number>
  }) {
    return http.post(apis2.OpenEngineerApi.updateServiceDesks, param)
  }
}
